import React from 'react';
import CollapsibleComponent from '../CollapsibleContainer';
import Label from '../form/Label/Label';
import OText from '../CText/OText';

const FrequentlyAskedQuestions = ({
  frequentlyAskedQuestion,
  title = 'Frequently Asked Questions',
}) => {
  return (
    <>
      <Label type="H5" typeHeader={'h5'} className="margb16">
        {title}
      </Label>
      {frequentlyAskedQuestion.map(item => (
        <div key={item?.question?.split(' ').join()}>
          <div className="margT16 bgWhite"> </div>
          <CollapsibleComponent
            className="flex-1 bgGray0 padR24"
            isExpanded={false}
            contentTitle={
              <Label type="Subtitle-1" className={' mSubtitle-1'} tabIndex="-1">
                {item?.question}
              </Label>
            }
          >
            <div className={'padL48 padR16 padB24 bgGray0'}>
              <Label className={'Body-2 mBody-2'}>
                <OText text={item?.answer} />
              </Label>
            </div>
          </CollapsibleComponent>
        </div>
      ))}
    </>
  );
};

export default FrequentlyAskedQuestions;
